import { ArraySchema, EntitySchema } from 'Lib/schemas';

import { MESSAGES_ENTITY_KEY } from 'Store/entities/entityKeys';

/**
 * Message Entity
 * ==============
 */
export const messageEntity = new EntitySchema(
  MESSAGES_ENTITY_KEY,
  {},
  {
    idAttribute: '_id',
    processStrategy(value: any) {
      if (value.created_date) {
        return {
          ...value,
          timestamp: Date.parse(value.created_date),
        };
      }
      return value;
    },
  }
);

export const likedMessageEntity = new EntitySchema(
  MESSAGES_ENTITY_KEY,
  {},
  {
    idAttribute: 'message_id',
  }
);

export const messageArray = new ArraySchema(messageEntity);
export const likedMessageArray = new ArraySchema(likedMessageEntity);
